var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_CASHIER_BOX = (storeId) => `api/store/${storeId}/cashierbox`;
export const getCashierboxesByStoreId = function (storeId, queryParams, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, options), { headers: { Authorization: `Bearer ${this.apiToken}` } });
            const response = yield this.axiosInstance.get(`${GET_SET_CASHIER_BOX(storeId)}?${queryParams || ''}`, config);
            return response;
        }
        catch (error) {
            throw error;
        }
    });
};
export const getCashierboxesById = function (storeId, id, queryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_CASHIER_BOX(storeId)}/${id}?${queryParams}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getCashierboxesById:', error);
            throw error;
        }
    });
};
export const getCashierBoxMovementsHistory = function (storeId, id, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            let queryParams = '';
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('pageNum')) {
                queryParams += `pageNum=${params === null || params === void 0 ? void 0 : params.pageNum}`;
            }
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('limit')) {
                queryParams += `&limit=${params === null || params === void 0 ? void 0 : params.limit}`;
            }
            const response = yield this.axiosInstance.get(`${GET_SET_CASHIER_BOX(storeId)}/${id}/history?${queryParams}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getCashierBoxMovementsHistory:', error);
            throw error;
        }
    });
};
